import { t } from 'i18next';

export function Logo() {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className="header_logo flex items-center gap-4 p-2 cursor-pointer bg-transparent border-none"
      onClick={handleScrollToTop}
      type="button"
      aria-label={t('header.logo.scrollToTop')}
    >
      <img
        src="/assets/icons/apple-icon-180x180.png"
        alt={t('header.logo.alt')}
        className="h-8 w-8"
      />
      <span className="text-xl font-bold">framerie</span>
    </button>
  );
}
